interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

export default function SubContainer({ children, className }: ContainerProps) {
  const common = 'gap-4';
  const mobile = 'col-span-4';
  const desktop = 'lg:col-span-12';
  const tablet = 'md:col-span-8';
  return <div className={`${mobile} ${tablet} ${desktop} ${common} ${className}`}>{children}</div>;
}
